<p-toast position="bottom-center"></p-toast>

<div class="card md-form-shell">
  <form
    [formGroup]="customerItemForm"
    novalidate
    autocomplete="off"
    autocorrect="off"
    autocapitalize="off"
    spellcheck="off"
    (ngSubmit)="saveCustomerItem()"
  >
    <div class="card-container bg-gray-100 border-round mt-2 p-4">
      <div class="mr-5 flex align-items-center mb-3">
        <i class="pi pi-file-edit mr-2 text-3xl"></i>
        <div class="font-medium text-3xl text-900">{{ pageTitle }}</div>
      </div>

      <div class="grid formgrid p-fluid">
        <div class="field col-12 md:col-6">
          <p-inputgroup>
            <p-inputgroup-addon><i class="pi pi-hashtag"></i></p-inputgroup-addon>
            <p-iftalabel>
              <input
                pInputText
                type="text"
                formControlName="customerItemNumber"
                id="customerItemNumber"
                class="w-full"
                placeholder="Enter customer item number"
              />
              <label for="customerItemNumber">Customer Item Number</label>
            </p-iftalabel>
          </p-inputgroup>
        </div>

        <div class="field col-12">
          <p-inputgroup>
            <p-inputgroup-addon><i class="pi pi-align-left"></i></p-inputgroup-addon>
            <p-iftalabel>
              <textarea
                pInputTextarea
                rows="3"
                formControlName="customerItemDescription"
                id="customerItemDescription"
                class="w-full"
                placeholder="Enter customer item description"
              ></textarea>
              <label for="customerItemDescription">Customer Item Description</label>
            </p-iftalabel>
          </p-inputgroup>
        </div>

        <app-entity-dropdown-picker
          formControlName="customer"
          [adapter]="customerPickerAdapter"
          inputId="customer"
          label="Customer"
          placeholder="Select a Customer"
          filterPlaceholder="Filter customers"
          columnClass="col-12 md:col-6"
          addonIconClass="pi pi-users"
        ></app-entity-dropdown-picker>

        <app-entity-dropdown-picker
          formControlName="tamerItem"
          [adapter]="tamerItemPickerAdapter"
          inputId="tamerItem"
          label="Tamer Item"
          placeholder="Select a Tamer Item"
          filterPlaceholder="Filter tamer items"
          columnClass="col-12 md:col-6"
          addonIconClass="pi pi-box"
        ></app-entity-dropdown-picker>

        <app-entity-dropdown-picker
          formControlName="brand"
          [adapter]="brandPickerAdapter"
          inputId="brand"
          label="Brand"
          placeholder="Brand is derived from the selected item"
          filterPlaceholder="Filter brands"
          columnClass="col-12 md:col-6"
          addonIconClass="pi pi-tags"
        ></app-entity-dropdown-picker>

        <app-entity-dropdown-picker
          formControlName="subBrand"
          [adapter]="subBrandPickerAdapter"
          inputId="subBrand"
          label="Sub Brand"
          placeholder="Sub brand is derived from the selected item"
          filterPlaceholder="Filter sub brands"
          columnClass="col-12 md:col-6"
          addonIconClass="pi pi-sitemap"
        ></app-entity-dropdown-picker>

        <div class="field col-12 md:col-6">
          <p-inputgroup>
            <p-inputgroup-addon><i class="pi pi-box"></i></p-inputgroup-addon>
            <p-iftalabel>
              <input
                pInputText
                type="text"
                formControlName="customerItemUom"
                id="customerItemUom"
                class="w-full"
                placeholder="Enter customer item UOM"
              />
              <label for="customerItemUom">Customer Item UOM</label>
            </p-iftalabel>
          </p-inputgroup>
        </div>

        <div class="field col-12 md:col-6">
          <p-inputgroup>
            <p-inputgroup-addon><i class="pi pi-box"></i></p-inputgroup-addon>
            <p-iftalabel>
              <input
                pInputText
                type="text"
                formControlName="itemUom"
                id="itemUom"
                class="w-full"
                placeholder="Derived from selected item"
              />
              <label for="itemUom">Item UOM</label>
            </p-iftalabel>
          </p-inputgroup>
        </div>

        <div class="field col-12 md:col-4">
          <p-inputgroup>
            <p-inputgroup-addon><i class="pi pi-money-bill"></i></p-inputgroup-addon>
            <p-iftalabel>
              <p-inputNumber
                formControlName="customerItemPrice"
                inputId="customerItemPrice"
                inputStyleClass="w-full"
                mode="decimal"
                [min]="0"
                [maxFractionDigits]="4"
              ></p-inputNumber>
              <label for="customerItemPrice">Customer Item Price</label>
            </p-iftalabel>
          </p-inputgroup>
        </div>

        <div class="field col-12 md:col-4">
          <p-inputgroup>
            <p-inputgroup-addon><i class="pi pi-list"></i></p-inputgroup-addon>
            <p-iftalabel>
              <p-inputNumber
                formControlName="caseCount"
                inputId="caseCount"
                inputStyleClass="w-full"
                mode="decimal"
                [min]="0"
                [maxFractionDigits]="0"
              ></p-inputNumber>
              <label for="caseCount">Case Count</label>
            </p-iftalabel>
          </p-inputgroup>
        </div>

        <div class="field col-12 md:col-4">
          <p-inputgroup>
            <p-inputgroup-addon><i class="pi pi-list"></i></p-inputgroup-addon>
            <p-iftalabel>
              <p-inputNumber
                formControlName="palletCount"
                inputId="palletCount"
                inputStyleClass="w-full"
                mode="decimal"
                [min]="0"
                [maxFractionDigits]="0"
              ></p-inputNumber>
              <label for="palletCount">Pallet Count</label>
            </p-iftalabel>
          </p-inputgroup>
        </div>
      </div>
    </div>

    <div class="mt-4 flex justify-content-end gap-2">
      <p-button
        label="Cancel"
        styleClass="p-button-secondary"
        type="button"
        (onClick)="cancel()"
      ></p-button>
      <p-button
        [label]="isEditMode ? 'Update Customer Item' : 'Save Customer Item'"
        type="submit"
        [disabled]="customerItemForm.invalid"
      ></p-button>
    </div>
  </form>
</div>
